<template>
  <v-dialog v-model="dialog" max-width="500" @keydown.esc="cancel()">
    <v-card tile>
      <v-card-title class="headline" primary-title>
        {{$t("Leave page")}}
      </v-card-title>
      <v-card-text>{{$t("You have unsaved changes. What do you want to do?")}}</v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" @click="leave">{{$t("Leave")}}</v-btn>
        <v-btn color="primary" @click="cancel">{{$t("Stay")}}</v-btn>
        <v-btn color="success" @click="submit">{{$t("Save and leave")}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  data () {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      message: null,
      title: null,
      routeTo: ''
    }
  },
  methods: {
    open (routeTo) {
      this.dialog = true
      this.routeTo = routeTo // Object.assign(this.options, options)
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    leave () {
      this.resolve('leave')
      this.dialog = false
      this.$router.push(this.routeTo)
    },
    submit () {
      this.dialog = false
      this.resolve('submit')
    },
    cancel () {
      this.resolve('cancel')
      this.dialog = false
    }
  }
}
</script>
